import { useTranslation } from 'react-i18next'
import { Languages } from 'lucide-react'

export default function LanguageSwitcher() {
    const { i18n } = useTranslation()

    const toggleLanguage = () => {
        const newLang = i18n.language === 'vi' ? 'en' : 'vi'
        i18n.changeLanguage(newLang)
    }

    const isVietnamese = i18n.language === 'vi'

    return (
        <button
            onClick={toggleLanguage}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white transition-all duration-300 shadow-md hover:shadow-lg"
            aria-label="Toggle language"
            title={isVietnamese ? 'Switch to English' : 'Chuyển sang Tiếng Việt'}
        >
            <Languages className="w-5 h-5" />
            <span className="text-2xl">{isVietnamese ? '🇻🇳' : '🇬🇧'}</span>
            <span className="text-sm font-semibold">
                {isVietnamese ? 'VI' : 'EN'}
            </span>
        </button>
    )
}

